export default __webpack_public_path__ + "static/media/AT.07194f10.svg";